import { memo } from 'react';
import Icon from '@/components/UI/icon/Icon';
import Box from '@/components/UI/box/Box';
import styles from './FutureDays.module.scss';
const FutureDays = ({
  day,
  isFull
}) => {
  return <Box className={`${styles['day-label']} ${isFull ? styles['calendare-lock-days'] : styles['day-is-disabled']}`} data-sentry-element="Box" data-sentry-component="FutureDays" data-sentry-source-file="FutureDays.tsx">
      <Box className={'day'} data-sentry-element="Box" data-sentry-source-file="FutureDays.tsx">{day}</Box>
      <>
        {isFull && <Box>
            <Icon size="medium" type={'lowEmphasis'} name={'lock'}></Icon>
          </Box>}
      </>
    </Box>;
};
export default memo(FutureDays);